import moment = require("moment");

const api = process.env.NEXT_PUBLIC_API || process.env.API || 'http://localhost:3200';
const apiSlideshow = process.env.NEXT_PUBLIC_API_SLIDESHOW || process.env.API_SLIDESHOW || api;
const apiImage = process.env.NEXT_PUBLIC_API_IMAGE || process.env.API_IMAGE || `${api}/files/`;
const apiChungThuc = process.env.NEXT_PUBLIC_API_CHUNG_THUC || process.env.API_CHUNG_THUC || api;
const apiFileUpload = process.env.NEXT_PUBLIC_API_FILE_UPLOAD || process.env.API_FILE_UPLOAD || `${api}/files/`;
const version = process.env.NEXT_PUBLIC_APP_VERSION || process.env.APP_VERSION || moment(new Date()).format('MMDDYYYYhhmm');

export default {
  app: {
    api,
    api_slideshow: apiSlideshow,
    api_image: apiImage,
    api_chung_thuc: apiChungThuc,
    api_file_upload: apiFileUpload,
    version,
  },
};
